export class Customer {
    constructor(props) {
        Object.assign(this, props);
    }
}
export class CustomerSales extends Customer {
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Customers/Model.ts
// module id = 333
// module chunks = 0